import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ProtectedRouteTenant = ({ auth, component, ...rest }) => {
  const navigate = useNavigate();
  let location = useLocation();
  const searchParams = location.search ? location.search : "";

  useEffect(() => {
    if (localStorage.getItem("usertype") != "tenant") {
      navigate(`/home${searchParams}`);
    }
  }, []);

  return component;
};

export default ProtectedRouteTenant;
